import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { backendApiUrls } from '@app/services/api/api.service';
import { AuthService } from '@app/services/auth/auth.service';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!backendApiUrls.has(req.url)) {
    return next(req);
  }

  const token = inject(AuthService).user?.token;

  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
